// Client-side beta gate for the Clients (`client_list`) module.
//
// NOTE: this is a cosmetic UI gate, not security. The email list ships inside
// the JS bundle (anyone inspecting source can read it) and the underlying
// objects/API are not restricted. It exists to keep the in-progress Clients
// feature hidden from most accounts during the beta. To change who can see it,
// edit CLIENTS_BETA_EMAILS and redeploy the web app.
const CLIENTS_BETA_EMAILS = [
  'frk314@gmail.com',
  'frkrueger@mac.com',
];

/** True if this email is allowed to see the Clients module. */
export function canSeeClients(email?: string | null): boolean {
  return !!email && CLIENTS_BETA_EMAILS.includes(email.trim().toLowerCase());
}
